import React from "react";
import "./Home.scss";
import { Link } from "react-router-dom";
import buscket from "../../images/buscket.svg";
import branch from "../../images/branch.svg";
import flag from "../../images/flag.svg";
import glasses from "../../images/glasses.svg";
import house from "../../images/house.svg";
import key from "../../images/key.svg";
import person from "../../images/person.svg";
import pills from "../../images/pills.svg";
import FrontPageCard from "../../components/FrontPageCards/Card";
import map from "../../images/map2.png";
// import farmacia from "../../images/farmacia.png";
// import years from "../../images/years.png";
// import hands from "../../images/hands.png";
import { useStoreState } from "easy-peasy";
import { ReactSVG } from "react-svg";
import * as conf from "../../../config";

function Home() {
  const forFrontPage = useStoreState((state) => state.api.forFrontPage);
  const front = useStoreState((state) => state.front.front);
  const picture = useStoreState((state) => state.banner.picture);
  const blur = useStoreState((state) => state.banner.blur);

  // const circles = [
  //   { title: "количество точек \n продаж, шт.", inner: front.storesnumber },
  //   { title: "площадь складских \n помещений, м2.", inner: front.werehouses },
  //   { title: "оборот, \n млн. руб.", inner: front.turnover },
  //   { title: "средний чек, \n руб.", inner: front.average },
  // ];
  const cards = [
    {
      title:
        "Розничные продажи \n лекарственных препаратов \n и готовых форм оптики",
      img: buscket,
    },
    { title: "Отпуск льготных \n лекартсвенных \n препаратов ", img: flag },
    { title: "Оптовые \n продажи", img: house },
    { title: "Изготовление \n лекарственных \n препаратов ", img: pills },
    {
      title: "Изготовление \n изделий оптики по \n индивидуальным заказам",
      img: glasses,
    },
    { title: "Услуги по хранению \n лекарственных \n препаратов", img: person },
    { title: "Аренда складских \n и офисных \nпомещений", img: key },
    { title: "Снабжение ФАП лекарственными препаратами", img: branch },
  ];
  return (
    <div className="Home">
      <div
        className="banner fullFlex"
        style={
          picture && {
            backgroundImage: `url(${conf.API_HOST + picture})`,
          }
        }
      >
        <div className="blur" style={{ backdropFilter: `blur(${blur})` }}></div>
        <div className="container">
          <div className="header">
            {front.title ? front.title : "К здоровью - вместе!"}
          </div>
          <div className="p">
            {front.text
              ? front.text
              : "АО «Фармация» - старейшая фармацевтическая компания Тюменской области."}
          </div>
          <Link to="/about">
            <BannerBtn />
          </Link>
        </div>
      </div>
      <div className="activities">
        <div className="container">
          <div className="header">ВИДЫ ДЕЯТЕЛЬНОСТИ</div>
          <div className="cardMain">
            {cards.map((el, ind) => (
              <div className="cardInner" key={ind}>
                {/* <img src={el.img} alt="" /> */}
                <ReactSVG src={el.img} />
                <div className="title">{el.title}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="news fullFlex">
        <div className="container">
          <div className="header">НОВОСТИ</div>
          <div className="cardsContainer">
            {forFrontPage.map((el, index) => (
              <React.Fragment key={index}>
                <FrontPageCard card={el} news={false} />
                {index == 0 && <div className="divider"></div>}
              </React.Fragment>
            ))}
          </div>
          <div className="btnContainer">
            <div className="btn red">
              <Link to="/news" style={{ color: "inherit" }}>
                ПОСМОТРЕТЬ ВСЕ
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="keyIndicators">
        <div className="container">
          <div className="header">
            КЛЮЧЕВЫЕ ПОКАЗАТЕЛИ ао "ФАРМАЦИЯ" <br />
            <span>2020 ГОД</span>
          </div>
          <div className="circleContainer">
            {circles.map((el, index) => (
              <div className="circleCard" key={index}>
                <div className="circle">
                  <span>{el.inner}</span>
                </div>
                <div className="title">{el.title}</div>
              </div>
            ))}
          </div>
        </div>
      </div> */}
      <div className="mapContainer">
        <div className="container">
          <div className="map">
            <img src={map} alt="map" />
          </div>
          <div className="post">
            <table>
              <tbody>
                <tr>
                  <th>{front.stores}</th>
                  <td>точек отпуска</td>
                </tr>
                <tr>
                  <th>{front.employee}</th>
                  <td>сотрудников с фармацевтическим образованием</td>
                </tr>
                <tr>
                  <th>{front.city}</th>
                  <td>городов</td>
                </tr>
                <tr>
                  <th>{front.settlements}</th>
                  <td>населённых пунктов</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {/* <div className="historyContainer">
        <div className="container">
          <img src={farmacia} alt="farmacia" className="farmacia" />
          <ul className="list">
            <li>Качество</li>
            <li className="dot"></li>
            <li>Надежность</li>
            <li className="dot"></li>
            <li>Профессионализм</li>
          </ul>
          <img src={years} alt="years" className="years" />
          <img src={hands} alt="hands" className="hands" />
        </div>
      </div> */}
    </div>
  );
}

Home.getInitialProps = async () => {
  return { whatever: "stuff" };
};

const BannerBtn = () => {
  return <div className="btn red">ПОДРОБНЕЕ О КОМПАНИИ</div>;
};

export default Home;
